export default {
  // Used in the share dashboard's DataTable header + rows. Bigger and bolder
  // than `compact` so it stays visible against the paper-tinted header row.
  transfer: {
    container: "inline-flex items-center cursor-pointer text-text",
    checkbox:
      "w-5 h-5 border-2 border-text_secondary rounded-md flex items-center justify-center transition-colors hover:border-primary",
    checkbox_checked: "bg-primary border-primary",
    checkbox_unchecked: "bg-transparent",
    checkmark: "h-3.5 w-3.5 text-white",
    label: "text-sm font-medium",
    label_left: "mr-2",
    label_right: "ml-2",
    placeholder: "w-3.5 h-3.5 bg-transparent",
  },
}
